import { resourcePaths } from '../constants';

export function getAcceptableUrl(loading: boolean, id: string | undefined): string {
  const acceptableUrl = !loading && id;
  return acceptableUrl ? `${resourcePaths.ASSET2_REVIEW_ASSET}/${id}` : '';
}
